import { getLogoPath } from './LogoMapping';

const Logo = ({organizationName}) => {
  const logoPath = getLogoPath(organizationName);

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Mantis" width="100" />
     *
     */
    <>
      <img src={logoPath} alt="Logo" width="120" />
    </>
  );
};

export default Logo;
